import { useEffect, useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

// Colore solo se l'area contiene testo: azzurro (palette Lavoratore) / rosa (palette Ufficio).
const TONE = {
  worker: "bg-[#EDF5FA] border-[#93B4CC] text-[#22364D]",
  office: "bg-[#F0E1E7] border-[#E1CFD8] text-[#4A3340]",
};
const NEUTRAL = "bg-white border-slate-200 text-slate-700";

function NoteArea({ kind, title, value, editable, onSave, testid }) {
  const [draft, setDraft] = useState(value || "");
  const [saving, setSaving] = useState(false);
  useEffect(() => { setDraft(value || ""); }, [value]);
  const filled = (editable ? draft : value || "").trim().length > 0;
  const dirty = draft.trim() !== (value || "").trim();
  const save = async () => {
    setSaving(true);
    try { await onSave(draft); } finally { setSaving(false); }
  };
  return (
    <div className={`rounded-xl border px-3 py-2.5 ${filled ? TONE[kind] : NEUTRAL}`} data-testid={testid}>
      <p className="text-xs font-bold uppercase tracking-wider mb-1.5">{title}</p>
      {editable ? (
        <>
          <Textarea value={draft} onChange={(e) => setDraft(e.target.value)} rows={3} maxLength={4000}
            data-testid={`${testid}-input`} className="bg-white/70 text-sm" />
          <div className="flex justify-end mt-2">
            <Button type="button" size="sm" disabled={!dirty || saving} onClick={save}
              data-testid={`${testid}-save`} className="rounded-lg font-semibold h-8">
              {saving ? "Salvataggio…" : "Salva nota"}
            </Button>
          </div>
        </>
      ) : (
        <p className="text-sm whitespace-pre-wrap break-words" data-testid={`${testid}-text`}>
          {filled ? value : <span className="text-slate-400">—</span>}
        </p>
      )}
    </div>
  );
}

// Note generali del Libro Presenze (una sola coppia, in fondo al Libro).
export function LibroNotes({ notes, editor, onSave, testidPrefix = "libro-notes" }) {
  return (
    <div className="space-y-2.5" data-testid={testidPrefix}>
      <NoteArea kind="worker" title="Note lavoratore" value={notes?.worker_note} editable={editor === "worker"}
        onSave={onSave} testid={`${testidPrefix}-worker`} />
      <NoteArea kind="office" title="Note ufficio" value={notes?.office_note} editable={editor === "office"}
        onSave={onSave} testid={`${testidPrefix}-office`} />
    </div>
  );
}
